import React from 'react';
import { LayoutProvider } from '../layout/context/layoutcontext';
import Layout from '../layout/layout';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import '../styles/layout/layout.scss';
import '../styles/demo/Demos.scss';
import { SessionProvider } from "next-auth/react";
import { setupIdleTime } from '../utilities/idletime';
import { useEffect,useState } from 'react';
import Idletime from '../components/idletime';
import { GeneralProvider } from '../context/generalcontext';
import ToastComponent from '../components/ToastComponent';
import { PagesProgressBar as ProgressBar } from 'next-nprogress-bar';      

export default function MyApp({ Component,  pageProps: { session, ...pageProps } }) {

    if (Component.getLayout) {
        return ( 
            <SessionProvider session={session}> 
                <LayoutProvider>
                <ProgressBar
                    height="4px"
                    color="#3B82F6"
                    options={{ showSpinner: false }}
                    shallowRouting
                />
                     <GeneralProvider>
                            <ToastComponent/>
                            {/* <Idletime/> */}
                            {Component.getLayout(<Component {...pageProps} />)}
                     </GeneralProvider>
                    </LayoutProvider> 
            </SessionProvider>
        );

    } else {
        return (
            <SessionProvider session={session}>
                <LayoutProvider>
                <ProgressBar
                    height="4px"
                    color="#3B82F6"
                    options={{ showSpinner: false }}
                    shallowRouting
                />
                    <Layout>
                        <GeneralProvider>
                            <ToastComponent/>
                            {/* <Idletime/> */}
                            <Component {...pageProps} />
                        </GeneralProvider>
                    </Layout>
                </LayoutProvider>
            </SessionProvider>
        );
    }
}